export const _420P = 420;

export const _576P = 576;
export const _576P_CENTER_PANEL_WIDTH = (521 / _576P) * 100;
export const _576P_CENTER_PANEL_L_MARGIN = (32 / _576P) * 100;

export const _708P = 708;
export const _768P = 768;
export const _768P_SIDE_PANEL_WIDTH = (112 / _768P) * 100;
export const _768P_CENTER_PANEL_WIDTH = (518.5 / _768P) * 100;
export const _768P_SIDE_PANEL_L_MARGIN = (8 / _768P) * 100;
export const _768P_SIDE_PANEL_R_MARGIN = (8 / _768P) * 100;

export const _780P = 780;
export const _840P = 840;
export const _992P = 992;

export const _1080P = 1080;
export const _1150P = 1150;
export const _1200P = 1200;

export const _1280P = 1280;
export const _1280P_SIDE_PANEL_WIDTH = (208 / _1280P) * 100;
export const _1280P_CENTER_PANEL_WIDTH = (520 / _1280P) * 100;
export const _1280P_SIDE_PANEL_R_MARGIN = (16 / _1280P) * 100;
export const _1280P_SIDE_PANEL_L_MARGIN = (160 / _1280P) * 100;

export const _1440P = 1440;
export const _1440P_SIDE_PANEL_WIDTH = (208 / _1440P) * 100;
export const _1440P_CENTER_PANEL_WIDTH = (650 / _1440P) * 100;
export const _1440P_SIDE_PANEL_R_MARGIN = (16 / _1440P) * 100;
export const _1440P_SIDE_PANEL_L_MARGIN = (176 / _1440P) * 100;

export const _1920P = 1920;
export const _1920P_CENTER_PANEL_WIDTH = (859 / _1920P) * 100;
export const _1920P_SIDE_PANEL_WIDTH = (277.56 / _1920P) * 100;
export const _1920P_SIDE_PANEL_R_MARGIN = (21.35 / _1920P) * 100;
export const _1920P_SIDE_PANEL_L_MARGIN = (234.86 / _1920P) * 100;

export const _943P = 943;

export const MINIMUM_CHAT_WINDOW_HEIGHT = 280;
